import React, { Suspense, lazy, createContext } from "react";
import { connect } from "react-redux";
import { fetchJSON } from "helpers/axios";
import axios from "axios";
import ContainerHeader from "components/ContainerHeader/index";
import IntlMessages from "util/IntlMessages";
import LoadingOverlay from "react-loading-overlay";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import GetAppIcon from "@material-ui/icons/GetAppTwoTone";
import { Cancel } from "@material-ui/icons";
import Widget from "components/Widget/index";
import {
  Box,
  Step,
  Stepper,
  StepLabel,
  Paper,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
  Slide,
} from "@material-ui/core";
import MaterialTable from "material-table";
import { tableIcons } from "../../../constants/Icons";
import SweetAlert from "react-bootstrap-sweetalert";
import { regStatus, userSignOut } from "actions/Auth";
import html2canvas from "html2canvas";
import GenericPdfDownloader from "./downloadPDF";
import Alert from "@material-ui/lab/Alert";
import CloseIcon from "@material-ui/icons/Close";
import ApplicantForm from "../../../components/ApplicantForm";
import RemitaLogo from "../../../assets/images/remita-logo.png";
const Checkout = lazy(() => import("./checkout"));
import Rimta from "./img/remmita.jpeg";
import nomba from "../../../assets/images/nombaLogo.png";
import monnify from "../../../assets/images/monnifyLogo.png";
import FullAdmissionLetter from "./FullAdmissionLetter";
import AdmLetterPg2 from "./AdmLetterPg2";

// const PostUmtePayRec = lazy(() => import("./postUtmePayRec"));
// const SiwesLetter = lazy(() => import("./siwes"));
const PaymentReceipt = lazy(() => import("./paymentReceipt"));
const SchoolFeeChart = lazy(() => import("./schoolFeeChart"));
const Acceptance = lazy(() => import("./acceptance"));
const AdmLetter = lazy(() => import("./AdmLetter"));

window.html2canvas = html2canvas;

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const DashboardContext = createContext();
const useStyles = makeStyles((theme) => ({
  root: {
    width: "90%",
  },
}));
const margin = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

const specialElementHandlers = {
  "#bypassme": function(element, renderer) {
    return true;
  },
};

const data = [
  "BAC/CERT/2400038",
  "BAC/CERT/2400047",
  "BAC/CERT/2400054",
  "BAC/HND/2400003",
  "BAC/HND/2400005",
  "BAC/HND/2400006",
  "BAC/HND/2400009",
  "BAC/HND/2400010",
  "BAC/HND/2400011",
  "BAC/HND/2400012",
  "BAC/HND/2400013",
  "BAC/HND/2400016",
  "BAC/ND/2400005",
  "BAC/ND/2400008",
  "BAC/ND/2400010",
  "BAC/ND/2400015",
  "BAC/ND/2400016",
  "BAC/ND/2400018",
  "BAC/ND/2400020",
  "BAC/ND/2400021",
  "BAC/ND/2400023",
  "BAC/ND/2400024",
  "BAC/ND/2400025",
  "BAC/ND/2400027",
  "BAC/ND/2400029",
  "BAC/ND/2400030",
  "BAC/ND/2400031",
  "BAC/ND/2400032",
  "BAC/ND/2400034",
  "BAC/ND/2400035",
  "BAC/ND/2400037",
  "BAC/ND/2400041",
  "BAC/ND/2400043",
  "BAC/ND/2400044",
  "BAC/ND/2400045",
  "BAC/ND/2400049",
  "BAC/ND/2400052",
  "BAC/ND/2400053",
  "BAC/ND/2400055",
  "BAC/ND/2400058",
  "BAC/CERT/2400002",
  "BAC/CERT/2400012",
  "BAC/CERT/2400014",
  "BAC/UTME-FRM/2400130",
  "BAC/UTME-FRM/2400133",
  "BAC/UTME-FRM/2400134",
  "BAC/UTME-FRM/2400139",
  "BAC/UTME-FRM/2400149",
  "BAC/UTME-FRM/2400153",
  "BAC/UTME-FRM/2400154",
  "BAC/UTME-FRM/2400162",
  "BAC/UTME-FRM/2400164",
  "BAC/UTME-FRM/2400168",
  "BAC/UTME-FRM/2400169",
  "BAC/UTME-FRM/2400176",
  "BAC/UTME-FRM/2400177",
  "BAC/UTME-FRM/2400187",
  "BAC/UTME-FRM/2400194",
  "BAC/UTME-FRM/2400197",
  "BAC/UTME-FRM/2400201",
  "BAC/UTME-FRM/2400223",
  "BAC/UTME-FRM/2400224",
  "BAC/UTME-FRM/2400225",
  "BAC/UTME-FRM/2400227",
  "BAC/UTME-FRM/2400228",
  "BAC/UTME-FRM/2400240",
  "BAC/UTME-FRM/2400241",
  "BAC/UTME-FRM/2400242",
  "BAC/UTME-FRM/2400243",
  "BAC/UTME-FRM/2400244",
  "BAC/UTME-FRM/2400245",
  "BAC/UTME-FRM/2400252",
  "BAC/UTME-FRM/2400253",
  "BAC/UTME-FRM/2400255",
  "BAC/UTME-FRM/2400257",
  "BAC/UTME-FRM/2400258",
  "BAC/UTME-FRM/2400259",
  "BAC/UTME-FRM/2400260",
  "BAC/UTME-FRM/2400263",
  "BAC/UTME-FRM/2400267",
  "BAC/UTME-FRM/2400272",
  "BAC/ND/2400006",
  "BAC/ND/2400009",
  "BAC/ND/2400013",
  "BAC/ND/2400022",
  "BAC/UTME-FRM/2400136",
  "BAC/UTME-FRM/2400175",
  "BAC/UTME-FRM/2400179",
  "BAC/UTME-FRM/2400181",
  "BAC/UTME-FRM/2400183",
  "BAC/UTME-FRM/2400202",
  "BAC/UTME-FRM/2400203",
  "BAC/UTME-FRM/2400216",
  "BAC/UTME-FRM/2400218",
  "BAC/UTME-FRM/2400111",
  "BAC/CERT/2400038",
  "BAC/CERT/2400042",
  "BAC/CERT/2400047",
  "BAC/CERT/2400054",
  "BAC/HND/2400002",
  "BAC/HND/2400003",
  "BAC/HND/2400004",
  "BAC/HND/2400005",
  "BAC/HND/2400006",
  "BAC/HND/2400007",
  "BAC/HND/2400008",
  "BAC/HND/2400009",
  "BAC/HND/2400010",
  "BAC/HND/2400011",
  "BAC/HND/2400012",
  "BAC/HND/2400013",
  "BAC/HND/2400014",
  "BAC/HND/2400015",
  "BAC/HND/2400016",
  "BAC/ND/2400003",
  "BAC/ND/2400004",
  "BAC/ND/2400005",
  "BAC/ND/2400006",
  "BAC/ND/2400008",
  "BAC/ND/2400009",
  "BAC/ND/2400010",
  "BAC/ND/2400011",
  "BAC/ND/2400013",
  "BAC/ND/2400015",
  "BAC/ND/2400016",
  "BAC/ND/2400017",
  "BAC/ND/2400019",
  "BAC/ND/2400020",
  "BAC/ND/2400021",
  "BAC/ND/2400022",
  "BAC/ND/2400023",
  "BAC/ND/2400024",
  "BAC/ND/2400025",
  "BAC/ND/2400027",
  "BAC/ND/2400029",
  "BAC/ND/2400030",
  "BAC/ND/2400031",
  "BAC/ND/2400032",
  "BAC/ND/2400034",
  "BAC/ND/2400035",
  "BAC/ND/2400036",
  "BAC/ND/2400037",
  "BAC/ND/2400039",
  "BAC/ND/2400040",
  "BAC/ND/2400041",
  "BAC/ND/2400043",
  "BAC/ND/2400044",
  "BAC/ND/2400045",
  "BAC/ND/2400046",
  "BAC/ND/2400048",
  "BAC/ND/2400049",
  "BAC/ND/2400050",
  "BAC/ND/2400051",
  "BAC/ND/2400052",
  "BAC/ND/2400053",
  "BAC/ND/2400055",
  "BAC/ND/2400056",
  "BAC/ND/2400057",
  "BAC/ND/2400058",
  "BAC/ND/2400059",
  "BAC/CERT/2400002",
  "BAC/CERT/2400007",
  "BAC/CERT/2400012",
  "BAC/CERT/2400014",
  "BAC/CERT/2400026",
  "BAC/CERT/2400028",
  "BAC/CERT/2400033",
  "202441416544IF",
  "202441887704JF",
  "202440230196CF",
  "202441273142DF",
  "202440400035DF",
  "202441966485GA",
  "202440019429CF",
  "202440099447HF",
  "202441755350JF",
  "202440416208BF",
  "202441444911IF",
  "202441291104JF",
  "202441079694IA",
  "202440622343JA",
  "202441068750IA",
  "202440205100BA",
  "202441072489AF",
  "202441072492IF",
  "202441449306FF",
  "202441077631EA",
  "202440072743CF",
  "202440171047DF",
  "202440299944DA",
  "202441072638CA",
  "202441008031FF",
  "202440664703EF",
  "202440900289CA",
  "202440898939CF",
  "202440365325CA",
  "202441445699EA",
  "202441445458BA",
  "202441711955JA",
  "202440674182FF",
  "202441641268DA",
  "202441115819FA",
  "202440726713HF",
  "202441169635BA",
  "202441795048GA",
  "202441057523HA",
  "202441522878DF",
  "202440081523BF",
  "202441051432DA",
  "202441170648HF",
  "202440431173FA",
  "202441738789GA",
  "202440069536AF",
  "202440182202CF",
  "202441106973BA",
  "202440081594EA",
  "202441056948JF",
  "202440255650FF",
  "202440567592FF",
  "202441502832EA",
  "202441269688BF",
  "202441320834CF",
  "202440453154GA",
  "BAC/CERT/2400002",
  "BAC/ND/2400005",
  "BAC/ND/2400009",
  "BAC/ND/2400008",
  "BAC/ND/2400006",
  "BAC/ND/2400010",
  "BAC/UTME-FRM/2400136",
  "BAC/UTME-FRM/2400169",
  "BAC/UTME-FRM/2400134",
  "BAC/UTME-FRM/2400164",
  "BAC/UTME-FRM/2400162",
  "BAC/UTME-FRM/2400168",
  "BAC/CERT/2400012",
  "BAC/UTME-FRM/2400175",
  "BAC/ND/2400013",
  "BAC/CERT/2400014",
  "BAC/UTME-FRM/2400176",
  "BAC/UTME-FRM/2400177",
  "BAC/ND/2400018",
  "BAC/ND/2400016",
  "BAC/ND/2400015",
  "BAC/UTME-FRM/2400179",
  "BAC/UTME-FRM/2400181",
  "BAC/UTME-FRM/2400197",
  "BAC/UTME-FRM/2400202",
  "BAC/UTME-FRM/2400203",
  "BAC/UTME-FRM/2400224",
  "BAC/UTME-FRM/2400216",
  "BAC/UTME-FRM/2400218",
  "BAC/UTME-FRM/2400223",
  "BAC/UTME-FRM/2400133",
  "BAC/UTME-FRM/2400153",
  "BAC/UTME-FRM/2400149",
  "BAC/UTME-FRM/2400183",
  "BAC/ND/2400020",
  "BAC/ND/2400021",
  "BAC/ND/2400022",
  "BAC/ND/2400023",
  "BAC/HND/2400003",
  "BAC/UTME-FRM/2400201",
  "BAC/UTME-FRM/2400130",
  "BAC/ND/2400024",
  "BAC/UTME-FRM/2400227",
  "BAC/ND/2400025",
  "BAC/UTME-FRM/2400154",
  "BAC/UTME-FRM/2400187",
  "BAC/UTME-FRM/2400139",
  "BAC/UTME-FRM/2400242",
  "BAC/UTME-FRM/2400194",
  "BAC/ND/2400027",
  "BAC/ND/2400029",
  "BAC/ND/2400030",
  "BAC/ND/2400031",
  "BAC/ND/2400032",
  "BAC/HND/2400005",
  "BAC/UTME-FRM/2400240",
  "BAC/UTME-FRM/2400241",
  "BAC/UTME-FRM/2400244",
  "BAC/UTME-FRM/2400228",
  "BAC/HND/2400010",
  "BAC/HND/2400009",
  "BAC/HND/2400006",
  "BAC/ND/2400034",
  "BAC/HND/2400011",
  "BAC/ND/2400035",
  "BAC/UTME-FRM/2400245",
  "BAC/UTME-FRM/2400253",
  "BAC/UTME-FRM/2400255",
  "BAC/CERT/2400038",
  "BAC/ND/2400037",
  "BAC/UTME-FRM/2400259",
  "BAC/ND/2400041",
  "BAC/HND/2400012",
  "BAC/UTME-FRM/2400257",
  "BAC/UTME-FRM/2400258",
  "BAC/UTME-FRM/2400252",
  "BAC/ND/2400043",
  "BAC/ND/2400044",
  "BAC/ND/2400045",
  "BAC/CERT/2400047",
  "BAC/UTME-FRM/2400225",
  "BAC/UTME-FRM/2400260",
  "BAC/ND/2400052",
  "BAC/ND/2400049",
  "BAC/CERT/2400054",
  "BAC/ND/2400053",
  "BAC/ND/2400055",
  "BAC/HND/2400013",
  "BAC/UTME-FRM/2400267",
  "BAC/UTME-FRM/2400272",
  "BAC/UTME-FRM/2400243",
  "BAC/ND/2400058",
  "BAC/HND/2400016",
  "BAC/UTME-FRM/2400263",
  "202441486044JF",
];

class Dashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      loader: true,
      pwdDialog: false,
      status: false,
      activeStep: 0,
      IsOlevelSaved: false,
      IsBiodataSaved: false,
      RegComplete: false,
      Admitted: false,
      warning: false,
      acceptance: 0,
      IsPasswdChgd: false,
      AdmissionStatus: false,
      IsDocUpload: false,
      admissionLetterDrawer: false,
      paymentDialog: false,
      message: "",
      statusResponse: null,
      remitaResponse: null,
      paymentType: null,
      transactionStatus: null,
      activeDraw: 0,
      isResultSaved: false,
      downloadDoc: [
        {
          fileExt: "",
          formId: 1,
          formUrl: "",
          levelIds: null,
          formName: "Provisional Admission Letter",
          departmentIds: null,
          formDescription: "View Letter showing Provisional Admission Details",
        },
        // {
        //   fileExt: "",
        //   formId: 2,
        //   formUrl: "",
        //   levelIds: null,
        //   formName: "Receipt Payment for  Acceptance",
        //   departmentIds: null,
        //   formDescription: "View Payment for Acceptance Receipt Details",
        // },
        // {
        //   fileExt: "",
        //   formId: 3,
        //   formUrl: "",
        //   levelIds: null,
        //   formName: "School Fees Chart",
        //   departmentIds: null,
        //   formDescription: "View School Fees Chart Details",
        // },
        // {
        //   fileExt: "",
        //   formId: 4,
        //   formUrl: "",
        //   levelIds: null,
        //   formName: "Acceptance Form",
        //   departmentIds: null,
        //   formDescription: "View Acceptance Form Details",
        // },
        // {
        //   fileExt: "",
        //   formId: 5,
        //   formUrl: "",
        //   levelIds: 3,
        //   formName: "SIWES",
        //   departmentIds: null,
        //   formDescription: "View SIWES Form Details",
        // },
      ],
      applicantData: [],
      applicationSlip: false,
      olevel: [],
      CourseofStudy: "",
      acceptPayment: [],
      checkifApplicantsExist: false,
    };
  }

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  getSteps = () => {
    return [
      "Biodata",
      "Results",
      "Documents",
      "Registration Completed",
      "Admitted",
    ];
  };

  async componentDidMount() {
    try {
      this.loadContent();
      //this.applicantOlevel();
      this.status();
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  }

  onCancelWarning = () => {
    this.setState({
      warning: false,
    });
  };

  closePayment = (val) => {
    this.setState({
      paymentDialog: val,
    });
    // this.setState({
    //   paymentStatus: val,
    // });
  };
  // closePaymentStatus = (val) => {
  //   this.setState(
  //     {
  //       paymentStatus: val,
  //     },
  //     this.props.history.push("/applicant/dashboard")
  //   );
  // };
  closePaymentStatus = (val) => {
    this.setState(
      {
        paymentStatus: val,
      },
      () => {
        // Reload the page and navigate to the desired route
        window.location.href = "/applicant/dashboard";
      }
    );
  };

  // Applicant Olevel
  applicantOlevel = async () => {
    try {
      const { token, ApplicantID } = this.props.authUser;
      const response = await fetchJSON(
        `api/OResults/NewhasOlevelResult?applicantId=${ApplicantID}`,
        null,
        "GET",
        token
      );
      if (response.Status === "Ok") {
        this.setState({
          olevel: response.Data,
        });
      } else {
        NotificationManager.error(response.Message);
      }
    } catch (error) {
      NotificationManager.error("An error occurred.");
    }
  };

  status = async () => {
    this.setState({ loader: true });

    try {
      const { token } = this.props.authUser;
      const urlParams = new URLSearchParams(window.location.search);
      const transactionReference = urlParams.get("paymentReference");
      const nombaReference = urlParams.get("orderId");

      // If neither reference exists, exit early
      // if (!transactionReference && !nombaReference) {
      //   throw new Error("No payment reference found");
      // }
      this.setState({ loader: true });
      let response;

      if (transactionReference) {
        response = await fetchJSON(
          `api/CheckPayeePaymentMonnify?paymentReference=${transactionReference}`,
          null,
          "GET",
          token
        );

        // Handle Monnify payment response
        if (response.Status === "Ok" && response.Data?.status === "Success") {
          this.setState({
            transactionStatus: "success",
            paymentStatus: true,
            message: "Payment successful! Thank you.",
            statusResponse: response?.Data,
            loader:false,
          });
        } else if (response.Status === "Error") {
          this.setState({
            transactionStatus: "failure",
            message: "Payment failed or not completed. Please try again.",
          });
        }
      } else if (nombaReference) {
        response = await fetchJSON(
          `api/CheckPayeePaymentNomba?paymentReference=${nombaReference}`, // Fixed endpoint URL
          null,
          "GET",
          token
        );

        // Handle Nomba payment response
        this.setState({
          transactionStatus: "success",
          paymentStatus: true,
          message: "Payment successful! Thank you.",
          statusResponse: response?.Data,
          loader:false
        });
      }
    } catch (error) {
      console.error("Payment status check failed:", error);
      this.setState({
        transactionStatus: "failure",
        message: "An error occurred while checking payment status.",
      });
    } finally {
      this.setState({ loader: false });
    }
  };

  /* #region  Download function for pdf */
  download = (rowData) => {
    try {
      axios({
        url: rowData.formUrl,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        NotificationManager.success("Download will begin shortly!");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${rowData.formName}.${rowData.fileExt}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    } catch (error) {
      NotificationManager.error("An error occurred!");
    }
  };
  /* #endregion */

  handleRequestClose = () => {
    this.setState({ pwdDialog: false });
    this.props.history.push("/applicant/changepassword");
  };

  checkMatricNumber = (matricNo, dataArray) => {
    if (!matricNo) return false;

    // Check if the auth user's matric number is in the data array
    return dataArray.includes(matricNo);
  };
  /* #region run on load of page and get necessary documents for download for applicants */
  loadContent = async () => {
    try {
      const { token, ApplicantID, JambRegNo } = this.props.authUser;
      const isMatricInData = data.includes(JambRegNo);
      const response = await fetchJSON(
        `api/Applicants/GetApplicantRecordById?ApplicantID=${ApplicantID}`,
        null,
        "GET",
        token
      );

      const admissionDocs = await fetchJSON(
        `api/listofforms?type=${2}`,
        null,
        "GET",
        token
      );

      if (response.Status === "Ok") {
        let docs;
        const {
          IsOlevelSaved,
          IsBiodataSaved,
          RegComplete,
          IsPasswdChgd,
          AdmissionStatus,
          IsUploadDocument,
          AdmissionLevel,
          CourseofStudy,
        } = response.Data;
        if (admissionDocs.Data) {
          docs = [...this.state.downloadDoc, ...admissionDocs.Data];
        } else {
          docs = [...this.state.downloadDoc];
        }
        if (AdmissionLevel === 3 && isMatricInData === true) {
          this.setState({
            loader: true,
            checkifApplicantsExist: true,
          });
        }
        if (AdmissionLevel === 4) {
          const AcceptancePayment = await fetchJSON(
            `api/ApplicantAcceptancePaymentHistory?payeeId=${ApplicantID}`,
            null,
            "GET",
            token
          );
          if (AcceptancePayment.Status === "Ok") {
            this.setState({ acceptPayment: AcceptancePayment.Data });
          }
        }

        this.setState({
          loader: true,
          IsOlevelSaved: IsOlevelSaved,
          IsBiodataSaved: IsBiodataSaved,
          RegComplete: RegComplete,
          IsPasswdChgd: IsPasswdChgd,
          IsDocUpload: IsUploadDocument,
          AdmissionStatus: AdmissionStatus,
          Admitted: false,
          acceptance: AdmissionLevel,
          downloadDoc: docs,
          applicantData: response.Data,
          CourseofStudy: CourseofStudy,
        });
        if (IsPasswdChgd === null) {
          this.setState({ pwdDialog: true });
        }
      } else {
        NotificationManager.error("Unable to complete operation.");
      }
      this.setState({ loader: false });
    } catch (error) {
      this.setState({ loader: false });
      NotificationManager.error("An error occurred.");
    }
  };
  /* #endregion */

  /* #region  Get RRR and ready payment settings */
  initiateNomba = async () => {
    try {
      const {
        SessionID,
        SchoolID,
        token,
        DOB,
        FirstName,
        LastName,
        OtherName,
        Email,
        PhoneNumber,
        Gender,
        DepartmentName,
        // DOB,
        ApplicantID,
        DeptID,
        LevelID,
        JambRegNo,
        AdmModeId,
      } = this.props.authUser;

      this.setState({ loader: true });
      // PaymentCategoryId = 10 from backend
      let model = {
        SessionID: SessionID,
        SchoolID: SchoolID,
        FirstName: FirstName,
        OtherName: OtherName,
        LastName: LastName,
        DepartmentName: DepartmentName,
        Email: Email,
        PhoneNumber: PhoneNumber,
        Gender: Gender,
        // DateOfBirth: DOB,
        DeptID: DeptID,
        LevelID: LevelID,
        AdmModeId: AdmModeId,
        PayeeTypeId: 1,
        PaymentCategoryId: 10,
        PayeeId: ApplicantID,
        ApplicantID: ApplicantID,
        JambRegNo: JambRegNo,
        PayeeName: `${FirstName} ${OtherName} ${LastName}`,
        PaymentItemId: [2],
        PayeeEmail: Email,
      };

      const response = await fetchJSON(
        `api/AddPayeePaymentNomba?payType=${10}`,
        model,
        "POST",
        token
      );

      if (response.Status == "OK") {
        response.Data.token = token;
        response.Data.payerEmail = Email;
        response.Data.payerPhone = PhoneNumber;
        response.Data.payerName = model.PayeeName;
        response.Data.LevelID = LevelID;
        location.href = response?.Data?.checkOutUrl;
        this.setState({
          loader: false,
          remitaResponse: response.Data,
          paymentType: "Nomba",
          // paymentDialog: true,
        });
        NotificationManager.success("Transaction Ref generated successfully");
      } else {
        this.setState({ loader: false });
        NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred3");
      this.setState({ loader: false });
      e;
    }
  };
  initiateMonnify = async () => {
    try {
      const {
        SessionID,
        SchoolID,
        token,
        DOB,
        FirstName,
        LastName,
        OtherName,
        Email,
        PhoneNumber,
        Gender,
        DepartmentName,
        // DOB,
        ApplicantID,
        DeptID,
        LevelID,
        JambRegNo,
        AdmModeId,
      } = this.props.authUser;
      // const { FirstName,
      //   LastName,
      //   OtherName,
      //   Email,
      //   PhoneNumber,
      //   Gender,
      //   // DOB,
      //   ApplicantID,
      //   DeptID,
      //   LevelId,JambRegNo, AdmModeId } = applicantData;
      this.setState({ loader: true });
      // PaymentCategoryId = 10 from backend
      let model = {
        SessionID: SessionID,
        SchoolID: SchoolID,
        FirstName: FirstName,
        OtherName: OtherName,
        LastName: LastName,
        DepartmentName: DepartmentName,
        Email: Email,
        PhoneNumber: PhoneNumber,
        Gender: Gender,
        // DateOfBirth: DOB,
        DeptID: DeptID,
        LevelID: LevelID,
        AdmModeId: AdmModeId,
        PayeeTypeId: 1,
        PaymentCategoryId: 10,
        PayeeId: ApplicantID,
        ApplicantID: ApplicantID,
        JambRegNo: JambRegNo,
        PayeeName: `${FirstName} ${OtherName} ${LastName}`,
        PaymentItemId: [2],
        PayeeEmail: Email,
      };

      const response = await fetchJSON(
        `api/AddPayeePaymentMonnify?payType=${10}`,
        model,
        "POST",
        token
      );

      if (response.Status == "OK") {
        response.Data.token = token;
        response.Data.payerEmail = Email;
        response.Data.payerPhone = PhoneNumber;
        response.Data.payerName = model.PayeeName;
        response.Data.LevelID = LevelID;
        location.href = response?.Data?.checkOutUrl;
        this.setState({
          loader: false,
          remitaResponse: response.Data,
          paymentType: "Monnify",
          // paymentDialog: true,
        });
        NotificationManager.success("Transaction Ref generated successfully");
      } else {
        this.setState({ loader: false });
        NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred3");
      this.setState({ loader: false });
      e;
    }
  };
  /* #endregion */

  /* #region  Get RRR and ready payment settings */
  initiateRemita = async () => {
    try {
      const {
        SessionID,
        SchoolID,
        token,
        DOB,
        FirstName,
        LastName,
        OtherName,
        Email,
        PhoneNumber,
        Gender,
        DepartmentName,
        // DOB,
        ApplicantID,
        DeptID,
        LevelID,
        JambRegNo,
        AdmModeId,
      } = this.props.authUser;
      // const { FirstName,
      //   LastName,
      //   OtherName,
      //   Email,
      //   PhoneNumber,
      //   Gender,
      //   // DOB,
      //   ApplicantID,
      //   DeptID,
      //   LevelId,JambRegNo, AdmModeId } = applicantData;
      this.setState({ loader: true });
      // PaymentCategoryId = 10 from backend
      let model = {
        SessionID: SessionID,
        SchoolID: SchoolID,
        FirstName: FirstName,
        OtherName: OtherName,
        LastName: LastName,
        DepartmentName: DepartmentName,
        Email: Email,
        PhoneNumber: PhoneNumber,
        Gender: Gender,
        // DateOfBirth: DOB,
        DeptID: DeptID,
        LevelID: LevelID,
        AdmModeId: AdmModeId,
        PayeeTypeId: 1,
        PaymentCategoryId: 10,
        PayeeId: ApplicantID,
        ApplicantID: ApplicantID,
        JambRegNo: JambRegNo,
        PayeeName: `${FirstName} ${OtherName} ${LastName}`,
        PaymentItemId: [2],
        PayeeEmail: Email,
      };

      const response = await fetchJSON(
        `api/AddPayeePayment?payType=${10}`,
        model,
        "POST",
        token
      );

      // debugger;

      if (response.Status == "OK") {
        response.Data.token = token;
        response.Data.payerEmail = Email;
        response.Data.payerPhone = PhoneNumber;
        response.Data.payerName = model.PayeeName;
        response.Data.LevelID = LevelID;
        this.setState({
          loader: false,
          remitaResponse: response.Data,
          paymentType: "Remita",
          paymentDialog: true,
        });
        NotificationManager.success("Transaction Ref generated successfully");
      } else {
        this.setState({ loader: false });
        NotificationManager.error(response.Message);
        return false;
      }
    } catch (e) {
      NotificationManager.error("An Error Occurred3");
      this.setState({ loader: false });
      e;
    }
  };
  /* #endregion */

  //confirm reg submission=== === ===
  handleReg = async () => {
    const { token, ApplicantID } = this.props.authUser;
    const regcomplete = await fetchJSON(
      `/api/Applicants/SubmitReg?applicantId=${ApplicantID}`,
      null,
      "GET",
      token
    );

    if (regcomplete.Status === "OK") {
      this.props.regStatus(regcomplete.Data);
      this.setState((prevState) => ({ activeStep: prevState.activeStep }));
      this.setState({
        RegComplete: true,
        warning: false,
      });
    } else {
      NotificationManager.warning(regcomplete.Message);
    }
  };

  render() {
    const { Provider } = DashboardContext;
    const { match, width, authUser } = this.props;

    const {
      loader,
      isResultSaved,
      IsOlevelSaved,
      IsBiodataSaved,
      RegComplete,
      IsPasswdChgd,
      IsDocUpload,
      AdmissionStatus,
      downloadDoc,
      acceptance,
      admissionLetterDrawer,
      paymentDialog,
      message,
      transactionStatus,
      statusResponse,
      paymentStatus,
      remitaResponse,
      paymentType,
      activeDraw,
      applicationSlip,
      applicantData,
      olevel,
      checkifApplicantsExist,
      CourseofStudy,
      acceptPayment,
    } = this.state;
    const classes = useStyles;
    const steps = this.getSteps();
    const urlParams = new URLSearchParams(window.location.search);
    const transactionReference = urlParams.get("paymentReference");
    return (
      <Provider>
        <div className="app-wrapper">
          <div className="dashboard animated slideInUpTiny animation-duration-3">
            <ContainerHeader
              match={match}
              title={<IntlMessages id="sidebar.dashboard" />}
            />
            <Suspense
              fallback={
                <div
                  className="loader-view"
                  style={{
                    height:
                      width >= 1200
                        ? "calc(100vh - 265px)"
                        : "calc(100vh - 245px)",
                  }}
                >
                  <CircularProgress />
                </div>
              }
            >
              <LoadingOverlay active={loader} spinner text="Checking...">
                {acceptance == 4 || checkifApplicantsExist === true ? (
                  <>
                    {/* === === === Start of Admission Documents Table === === === */}
                    <Box className={`mt-5 ${classes.root}`}>
                      <MaterialTable
                        icons={tableIcons}
                        title="My Results"
                        columns={[
                          {
                            title: "S/N",
                            render: (rowData) => rowData.tableData.id + 1,
                          },
                          {
                            title: "Document Name",
                            field: "formName",
                            render: (rowData) => (
                              <Link
                                onClick={() =>
                                  rowData.formUrl == ""
                                    ? this.setState({
                                        admissionLetterDrawer: true,
                                        activeDraw: rowData.formId,
                                      })
                                    : this.download(rowData)
                                }
                              >
                                {rowData.formName}
                              </Link>
                            ),
                          },
                          {
                            title: "Description",
                            field: "formDescription",
                            cellStyle: {
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              padding: "0px",
                            },
                          },
                        ]}
                        data={downloadDoc}
                        actions={[
                          {
                            icon: () => <GetAppIcon color="action" />,
                            tooltip: "Download",
                            onClick: (event, rowData) => {
                              // debugger;
                              return (
                                (
                                  <Link
                                    to={rowData.formUrl}
                                    target="_blank"
                                    download
                                  >
                                    Download
                                  </Link>
                                ),
                                rowData.formUrl == ""
                                  ? this.setState({
                                      admissionLetterDrawer: true,
                                      activeDraw: rowData.formId,
                                    })
                                  : this.download(rowData)
                              );
                            },
                          },
                        ]}
                        options={{
                          toolbar: false,
                          actionsColumnIndex: -1,
                          pageSize: 5,
                          padding: "dense",
                          headerStyle: {
                            fontSize: "13px",
                            backgroundColor: "#ccc",
                            borderBottomColor: "#111",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          },
                          paging: false,
                        }}
                      />
                    </Box>
                  </>
                ) : acceptance == 3 ? (
                  <>
                    <Box className={classes.root}>
                      {/* <Alert severity="success" variant="outlined">
                        Congratulations, {authUser.LastName}{" "}
                        {authUser.FirstName}!!! You have been given provisonal
                        admission into{" "}
                        <strong>{authUser?.Applicant?.DepartmentName}</strong>{" "}
                        programme.
                      </Alert> */}

                      <Stepper
                        activeStep={this.state.activeStep + 5}
                        alternativeLabel
                        className=""
                      >
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </Box>
                    
                    <Widget
                      styleName="bg-primary text-white"
                      className="mt-0"
                      style={{ cursor: "pointer" }}
                    >
                      <div className="text-center">
                        <i className="text-center block mb-4">
                          ...pending acceptance fee payment
                        </i>
                      </div>

                      {/* <div className="w-full text-center my-4">
                        <i className="zmdi zmdi-card zmdi-hc-4x inline-block" />
                      </div> */}

                      <div className="text-center mt-2">
                        <h3
                          className="mb-3"
                          style={{ color: "#e6963e", fontWeight: "bolder" }}
                        >
                          Hello {authUser.LastName} {authUser.FirstName}
                        </h3>
                        <p
                          className="mb-3"
                          style={{ color: "#e3963e", fontWeight: "bolder" }}
                        >
                          Kindly complete acceptance fee payment to avoid
                          revocation of admission
                        </p>

                        <div className="flex flex-row items-center justify-center gap-4 w-full">
                         

                          <button
                            id="applyForm"
                            className="shadow-md bg-white border px-6 py-2 flex items-center justify-center min-w-[200px] rounded-lg transition-all duration-300 hover:bg-gray-50 hover:shadow-lg hover:scale-105"
                            onClick={() => this.initiateMonnify()}
                          >
                            <img
                              className="isw-pay-logo w-8 h-8"
                              src={monnify}
                              alt="monnify"
                              width="35px"
                            />
                            <span className="inline-block ml-3">
                              Pay with Monnify
                            </span>
                          </button>
                          <span className="text-lg font-medium px-4">OR</span>
                          <button
                            id="payRemita"
                            className="shadow-md bg-white border px-8 py-2 flex items-center justify-center min-w-[200px] rounded-lg transition-all duration-300 hover:bg-gray-50 hover:shadow-lg hover:scale-105"
                            onClick={() => this.initiateRemita()}
                            // cursor={pointer}
                            disabled={true}
                          >
                            <img
                              className="isw-pay-logo w-8 h-8"
                              src={Rimta}
                              alt="Remita"
                              width="30px"
                              height="30px"
                            />
                            <span className="inline-block ml-3">
                              Pay with Remita
                            </span>
                          </button>

                          <span className="text-lg font-medium px-4">OR</span>
                          <button
                            id="applyForms"
                            className="shadow-md bg-white border px-6 py-2 flex items-center justify-center min-w-[200px] rounded-lg transition-all duration-300 hover:bg-gray-50 hover:shadow-lg hover:scale-105"
                            onClick={() => this.initiateNomba()}
                          >
                            <img
                              className="isw-pay-logo w-8 h-8"
                              src={nomba}
                              alt="nomba"
                              width="35px"
                            />
                            <span className="inline-block ml-3">
                              Pay with Nomba
                            </span>
                          </button>
                        </div>
                      </div>
                    </Widget>
                    <Box className={`mt-4 ${classes.root}`}>
                      <MaterialTable
                        icons={tableIcons}
                        title="My Results"
                        columns={[
                          {
                            title: "S/N",
                            render: (rowData) => rowData.tableData.id + 1,
                          },
                          {
                            title: "Document Name",
                            field: "formName",
                            render: (rowData) => (
                              <Link
                                onClick={() =>
                                  rowData.formUrl == ""
                                    ? this.setState({
                                        admissionLetterDrawer: true,
                                        activeDraw: rowData.formId,
                                      })
                                    : this.download(rowData)
                                }
                              >
                                {rowData.formName}
                              </Link>
                            ),
                          },
                          {
                            title: "Description",
                            field: "formDescription",
                            cellStyle: {
                              whiteSpace: "nowrap",
                              maxWidth: "100%",
                              padding: "0px",
                            },
                          },
                        ]}
                        data={downloadDoc}
                        actions={[
                          {
                            icon: () => <GetAppIcon color="action" />,
                            tooltip: "Download",
                            onClick: (event, rowData) => {
                              // debugger;
                              return (
                                (
                                  <Link
                                    to={rowData.formUrl}
                                    target="_blank"
                                    download
                                  >
                                    Download
                                  </Link>
                                ),
                                rowData.formUrl == ""
                                  ? this.setState({
                                      admissionLetterDrawer: true,
                                      activeDraw: rowData.formId,
                                    })
                                  : this.download(rowData)
                              );
                            },
                          },
                        ]}
                        options={{
                          toolbar: false,
                          actionsColumnIndex: -1,
                          pageSize: 5,
                          padding: "dense",
                          headerStyle: {
                            fontSize: "13px",
                            backgroundColor: "#ccc",
                            borderBottomColor: "#111",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                          },
                          paging: false,
                        }}
                      />
                    </Box>
                  </>
                ) : AdmissionStatus ? (
                  <>
                    <Box className={classes.root}>
                      <Alert severity="success" variant="outlined">
                        Congratulations, {authUser.LastName}{" "}
                        {authUser.FirstName}, You have been granted admission!
                      </Alert>
                      <Stepper
                        activeStep={this.state.activeStep + 5}
                        alternativeLabel
                      >
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </Box>
                  </>
                ) : RegComplete ? (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep + 4}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    <Widget
                      styleName={`bg-primary text-white`}
                      className="mt-3"
                    >
                      <div className="d-flex flex-row justify-content-center mt-3">
                        <i className={`zmdi zmdi-timer zmdi-hc-4x`} />
                      </div>
                      <div className="text-center mt-2">
                        <h3 className="jr-font-weight-medium mb-3">
                          Hello {authUser.LastName} {authUser.FirstName}
                        </h3>
                        <p className="mb-3">
                          Your application is being reviewed!
                        </p>

                        <span
                          className="text-warning"
                          style={{ cursor: "", fontSize: "25px" }}
                          // onClick={() =>
                          //   this.setState({ applicationSlip: true })
                          // }
                        >
                          <strong>
                            Kindly Await Response From The Admissions Team
                            <i></i>
                          </strong>
                        </span>
                      </div>
                    </Widget>
                  </Box>
                ) : IsDocUpload ? (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep + 3}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    <Box className="mt-3 float-right">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          this.setState({ warning: true });
                        }}
                      >
                        Complete Registration
                      </Button>
                    </Box>
                  </Box>
                ) : IsBiodataSaved && IsOlevelSaved ? (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep + 2}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                ) : IsBiodataSaved ? (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep + 1}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                ) : (
                  <Box className={classes.root}>
                    <Stepper
                      activeStep={this.state.activeStep}
                      alternativeLabel
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                )}
                {/* === === === Start of Admission Status Stepper based on registration stages === === === */}
              </LoadingOverlay>
            </Suspense>
          </div>
        </div>
        <NotificationContainer />
        {/* === === === Start of Confirm Reg Dialog === === === */}
        <SweetAlert
          show={this.state.warning}
          warning
          showCancel
          confirmBtnText="Submit"
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="default"
          title="Are You Sure?"
          onConfirm={this.handleReg}
          onCancel={this.onCancelWarning}
        >
          You won't be able to change your details after you submit.
        </SweetAlert>
        {/* === === === End of Confirm Reg Dialog === === === */}
        {/* === === === Start of Change Password Dialog === === === */}
        <Dialog
          open={this.state.pwdDialog}
          onClose={(event) => {
            this.setState({ pwdDialog: true });
          }}
        >
          <DialogTitle>{"Welcome!"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Login successful! You are required to change your default
              password.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {/* <Button onClick={this.handleRequestClose} color="secondary">
                Disagree
              </Button> */}
            <Button onClick={this.handleRequestClose} color="primary">
              Proceed
            </Button>
          </DialogActions>
        </Dialog>

        {/* Admission Letter Dialog */}
        <Dialog
          fullScreen
          open={admissionLetterDrawer}
          onClose={this.toggleDrawer("admissionLetterDrawer", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#093368" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("admissionLetterDrawer", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                {downloadDoc.find((doc) => doc.formId === activeDraw)?.formName}
              </Typography>
              <GenericPdfDownloader
                downloadFileName="AdmissionLetterPdf"
                rootElementId="content"
              />
            </Toolbar>
          </AppBar>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            {activeDraw === downloadDoc[0]?.formId && (
              <div id="content">
                <AdmLetter applicant={authUser} applicantData={applicantData} />
                {/* <AdmLetterPg2 applicant={authUser} /> */}
              </div>
              // <FullAdmissionLetter applicant={authUser} />
            )}
            {activeDraw === downloadDoc[1]?.formId && (
              <PaymentReceipt
                rrrResponse={acceptPayment}
                token={this.props?.authUser?.token}
                applicantId={this?.props?.authUser}
              />
            )}
            {/* {activeDraw === downloadDoc[2]?.formId && (
              <PostUmtePayRec applicant={applicantData} />
            )} */}
            {activeDraw === downloadDoc[2]?.formId && (
              <SchoolFeeChart applicant={authUser} />
            )}
            {activeDraw === downloadDoc[3]?.formId && (
              <Acceptance applicant={authUser} />
            )}
            {/* {activeDraw === downloadDoc[4]?.formId && (
              <SiwesLetter applicant={authUser} />
            )} */}
          </Suspense>
        </Dialog>

        {/* Application Slip Dialog */}
        <Dialog
          fullScreen
          open={applicationSlip}
          onClose={this.toggleDrawer("applicationSlip", false)}
          TransitionComponent={Transition}
        >
          <AppBar
            className="position-relative"
            style={{ backgroundColor: "#093368" }}
          >
            <Toolbar>
              <IconButton
                style={{ color: "white" }}
                onClick={this.toggleDrawer("applicationSlip", false)}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="h5"
                style={{
                  flex: 1,
                  color: "white",
                }}
              >
                {downloadDoc.find((doc) => doc.formId === activeDraw)?.formName}
              </Typography>
              <GenericPdfDownloader
                downloadFileName="ApplicationSlipPdf"
                rootElementId="content"
              />
            </Toolbar>
          </AppBar>
          <ApplicantForm applicant={this.props.authUser} olevel={olevel} />
        </Dialog>

        {/* === === === Payment Dialog === === === */}
        <Dialog
          open={paymentDialog}
          fullWidth={true}
          TransitionComponent={Slide}
          onClose={(event) => this.closePayment(false)}
        >
          <DialogTitle
            disableTypography
            className="d-flex p-0"
            style={{ justifyContent: "flex-end" }}
          >
            <IconButton onClick={(event) => this.closePayment(false)}>
              <Cancel />
            </IconButton>
          </DialogTitle>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            <DialogContent
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Checkout
                payeeInfo={remitaResponse}
                stateChange={this.closePayment}
                paymentType={paymentType}
              />
            </DialogContent>
          </Suspense>
        </Dialog>
        {/* === === === Payment status === === === */}
        <Dialog
          open={paymentStatus}
          fullWidth={true}
          TransitionComponent={Slide}
          onClose={(event) => this.closePaymentStatus(false)}
        >
          <DialogTitle
            disableTypography
            className="d-flex p-0"
            style={{ justifyContent: "flex-end" }}
          >
            <IconButton onClick={(event) => this.closePaymentStatus(false)}>
              <Cancel />
            </IconButton>
          </DialogTitle>
          <Suspense
            fallback={
              <div
                className="loader-view"
                style={{
                  height:
                    width >= 1200
                      ? "calc(100vh - 265px)"
                      : "calc(100vh - 245px)",
                }}
              >
                <CircularProgress />
              </div>
            }
          >
            <DialogContent
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div className="text-center">
                {transactionReference ? (  <div style={{ marginBottom: "20px" }}>
                  <img
                    className="isw-pay-logo w-8 h-8"
                    src={monnify}
                    alt="monnify"
                    width="150px"
                  />
                </div>) : (  <div style={{ marginBottom: "20px" }}>
                  <img
                    className="isw-pay-logo w-8 h-8"
                    src={nomba}
                    alt="nomba"
                    width="150px"
                  />
                </div>)}
              

                <h4>{message}</h4>
                <h6>Transaction Reference: {statusResponse?.TransactionRef}</h6>
                {this.state.loader && <p>Loading...</p>}
                {this.state.transactionStatus === "success" && (
                  <div>
                    <strong>
                      <h6>What Next !</h6>
                    </strong>
                    <ul>
                      <li>
                        Your student login details have been sent to your email.
                      </li>
                      <li>
                        Your admission letter has also been sent to your email.
                      </li>
                    </ul>
                    Please check your email for further details.
                  </div>
                )}
              </div>
            </DialogContent>
          </Suspense>

          <button
            type="button"
            width="50px"
            className="btn btn-primary"
            onClick={(event) => this.closePaymentStatus(false)}
          >
            OK
          </button>
        </Dialog>
      </Provider>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const authUser = auth.applicantUser;
  const { userMode } = auth;
  return { authUser, userMode };
};

export default connect(mapStateToProps, { regStatus, userSignOut })(Dashboard);
export { DashboardContext };
